<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">


    <!-- Start Timeline Area -->
    <div class="rwt-timeline-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="报修服务"
                data-aos="fade-up"
            />
          </div>
          <div class="col-lg-12">
            <iframe class="iframe-gap" style="width:100%;height:750px;"  :src="src"></iframe>


          </div>
        </div>

      </div>


    </div>
  </Layout>
</template>

<script>
import Swipers from "../../components/elements/swiper/Swiper";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import Layout from "../../components/common/Layout";
export default {
  name: "ProductRepair",
  components:{Swipers, Layout,SectionTitle},
  data(){
    return{
      src: process.env.VUE_APP_BASE_URL+`/repair/applySite`

    }
  },
}
</script>

<style scoped>

</style>